import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const symptoms = ['Te despiertas y lo primero que haces es mirar si está en línea', 'Te dices "no le escribiré", y a las horas estás redactando un texto perfecto', 'Revisas historias y te arruinas el día por una foto', 'Te da vergüenza admitirlo, pero preferirías una respuesta fría a no tener nada', 'Te culpas: "¿por qué soy así?"', 'Y aun así… repites el bucle'];
  return <section className="bg-[#141210]" style={{
    paddingTop: 'var(--space-section)',
    paddingBottom: 'var(--space-section)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-116">
      <div className="max-w-2xl mx-auto" data-id="element-117">
        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="space-y-6 leading-relaxed text-[#F5F0EB]/90 font-light mb-24 fluid-lg" data-id="element-118">
          <p data-id="element-119">Hay un momento específico que casi nadie admite en voz alta.</p>
          <p data-id="element-120">No es cuando te dejan.</p>
          <p className="font-serif italic text-white fluid-2xl" data-id="element-121">Es después.</p>
          <p data-id="element-122">
            Cuando se te calma el llanto… y de repente te entra esa urgencia
            sucia, física:
          </p>
          <blockquote className="border-l-2 border-[#A52422] pl-6 py-2 my-8 text-white font-serif italic bg-[#A52422]/5 fluid-xl" data-id="element-123">
            "Voy a escribirle. Solo una cosa. Solo para aclarar. Solo para
            cerrar."
          </blockquote>
          <p data-id="element-124">Y ahí es cuando te pierdes.</p>
          <p data-id="element-125">Porque no es un mensaje.</p>
          <p data-id="element-126">
            Es volver a poner tu mano dentro de una puerta que ya te la pilló.
          </p>
          <p data-id="element-127">Este PDF no está hecho para que "entiendas" tu ruptura.</p>
          <p data-id="element-128">
            Está hecho para que pases la primera semana sin rogar, sin perseguir
            señales, sin convertir tu ansiedad en una conversación que te deja
            peor.
          </p>
          <p data-id="element-129">Sin prometerte que vuelve.</p>
          <p className="text-[#A52422] font-semibold" data-id="element-130">
            Prometiéndote algo más útil: un plan.
          </p>
        </motion.div>

        {/* Symptoms List */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-131">
          <h2 className="fluid-3xl font-bold text-white mb-10 font-serif" data-id="element-132">
            Si esto te está pasando,{' '}
            <span className="text-[#A52422] italic" data-id="element-133">no estás loca</span>
          </h2>

          <ul className="space-y-4 mb-12" data-id="element-134">
            {symptoms.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-start gap-4 text-[#F5F0EB]/80 fluid-base" data-id="element-135">
                <span className="mt-2.5 w-2 h-0.5 bg-[#A52422] shrink-0 rounded-full" data-id="element-136" />
                <span data-id="element-137">{item}</span>
              </motion.li>)}
          </ul>

          <div className="p-6 border border-[#A52422]/20 bg-[#A52422]/5 rounded-lg text-center" data-id="element-138">
            <p className="font-serif italic text-white fluid-xl" data-id="element-139">
              No es falta de amor propio. <br data-id="element-140" />
              <span className="text-[#A52422] not-italic font-sans font-medium mt-2 block fluid-base" data-id="element-141">
                Es tu sistema nervioso buscando alivio inmediato.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}